import React from 'react';
import { useTranslation } from 'react-i18next';

import styled from '@emotion/styled';
import { HeadingText40, HeadingText10, pxToRem } from '@modernhealth/vital-components';
import { MilestoneBadge } from 'src/modules/scheduledContent/components/MilestoneBadge';

import { MilestoneListTestID } from './testIds';

const Wrapper = styled.ul({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'start',
    gap: pxToRem(16),
    padding: 0,
    margin: 0,
});

interface MilestoneListProps {
    milestoneList: number[];
    completedCount?: number | null;
}

export const MilestoneList: React.FC<MilestoneListProps> = ({ milestoneList, completedCount }) => {
    const { t } = useTranslation();
    if (!completedCount) {
        return null;
    }

    return (
        <Wrapper>
            {milestoneList.map((milestone, idx) => {
                const isCompleted = completedCount >= milestone;

                return (
                    <li
                        aria-label={
                            isCompleted
                                ? t('dailyPause:milestones.list.full_description', {
                                      count: milestone,
                                  })
                                : t('dailyPause:milestones.list.incomplete_full_description', {
                                      count: milestone,
                                  })
                        }
                        key={`${idx}-${milestone}`}
                        data-testid={`${MilestoneListTestID.Badge}`}
                    >
                        <MilestoneBadge
                            isCompleted={isCompleted}
                            size={72}
                            children={
                                <HeadingText40 as="span" fontColor="white">
                                    {milestone}
                                </HeadingText40>
                            }
                            title={
                                <HeadingText10
                                    marginTop={12}
                                    fontColor={isCompleted ? 'gray85' : 'gray40'}
                                    as="span"
                                >
                                    {t('dailyPause:milestones.list.description', {
                                        count: milestone,
                                    })}
                                </HeadingText10>
                            }
                        />
                    </li>
                );
            })}
        </Wrapper>
    );
};
